import axios, { AxiosError } from "axios";
import { getData, removeCookie } from "utils/storage";

interface ApiInterface {
  method: string;
  url: string;
  data?: any;
  params?: any;
  headers?: any;
  withCredentials?: boolean;
}

const _api = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/v1/`,
});

_api.interceptors.request.use(
  function (config: any) {
    let token = getData("token");
    if (token) {
      config.headers["X-System-Auth"] = `${token}`;
    }

    // config.headers["X-System-Auth"] = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJnby1ncnBjLWF1dGgtc3lzdGVtIiwiVXNlcmlkIjoiR3JlYXRFZHUiLCJFbWFpbEFkZHIiOiIifQ.CTJVcNmX_A_h88c0cA04rJs6GyhjaymtnZHQOLLdJHs`;

    config.headers["Content-Type"] = `Application/json`;
    return config;
  },
  function (error: any) {
    return Promise.reject(error);
  }
);

const api = async ({
  method,
  url,
  data = null,
  params = null,
  withCredentials = false,
  headers = null,
}: ApiInterface) => {
  try {
    const response = await _api({
      method,
      url,
      data,
      params,
      withCredentials,
      headers
    });

    return response;
  } catch (err: any | AxiosError) {
    if (err.response.status === 401) {
      removeCookie("token");
    }

    throw err;
  }
};

export default api;
